import styled from 'styled-components';
import { CaptionText as CaptionTextComponent } from '@prisjakt/ui/text/variants';
import { layout } from '@prisjakt/ui-base';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${layout.measurements.spacing025};
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const CaptionText = styled(CaptionTextComponent)`
  white-space: nowrap;
`;
